module.exports = "<div class=\"modal-header heading\"><button type=button class=close ng-click=$close()>&times;</button><h3 class=modal-title>Amendments are not available</h3></div><div class=modal-body><p>This ticket is not eligible for amendments. Please contact support</p></div><div class=modal-footer><button class=\"btn btn-kt\" ng-click=modalCtrl.dismiss()>OK</button></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trip/trip-change-ticket/trip-change-ticket-not-eligible.html
// module id = 3390
// module chunks = 0